<mat-toolbar class="filter-bar mat-elevation-z3 flex" id="app-filterbar">
  <mat-icon color="primary flex-0">filter_list</mat-icon>
  <mat-chip-set class="flex-1">

    <!-- Placeholders: Show when filters are loading -->
    <div *ngIf="isLoadingFilters$ | async; else showFilters" class="w-full flex gap-3 px-5">
      <div *ngFor="let _ of [1,2]" class="mat-elevation-z2 placeholder-chip" syncPulse aria-hidden="true">
        <div class="placeholder-content">
          <div class="placeholder-icon"></div>
          <div class="placeholder-text"></div>
        </div>
      </div>
    </div>

    <!-- Actual Filters: Show when filters are loaded -->
    <ng-template #showFilters>
      <mat-chip #filterChip *ngFor="let filter of reportViewFilterSelections$ | async" class="sd-mat-chip" [removable]="filter.removeable">
        <span (click)="onFilterClicked($event, filterChip._elementRef, filter)" class="label">
          {{ getDisplayValue(filter, locale) | translate: locale | async }}
        </span>
        <button (click)="lockFilter(filter)" matChipAction>
          <mat-icon [fontIcon]="filter.locked ? 'lock' : 'lock_open'" [class.locked]="filter.locked" />
        </button>
        <button *ngIf="filter.removeable" (click)="removeFilter(filter)" matChipAction class="remove-icon">
          <mat-icon fontIcon="cancel" />
        </button>
      </mat-chip>

      <button #tempBtn (click)="showFilterPanel(tempBtn._elementRef)" mat-button color="primary" class="filter-button ml-2 mt-0.5">
        + {{'Filter' | translate: locale | async}}
      </button>
    </ng-template>

  </mat-chip-set>
  <button mat-icon-button color="primary" class="clear-filter-button flex-0" (click)="resetFilters()">
    <mat-icon>replay</mat-icon>
  </button>
</mat-toolbar>
